import useQueryParams from '@common/src/hooks/useQueryParams';
import { FLOWS_CONFIG_PATH } from '@flows/src/FlowsConfigRouter';
import { useYellowhiveFlowsConfigureStore } from '@flows/src/store/zustand/flows-configure/yellowhiveFlowsConfigureStore';
import QuestionViewSkeleton from '@sales-conversation/src/components/skeletons/QuestionViewSkeleton';
import { FC, useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import useStartYellowhiveOfferFlow from '@flows/src/hooks/flows-configure/useStartYellowhiveOfferFlow';

const FlowsConfigureYellowhiveFinish: FC = () => {
  const queryParams = useQueryParams();
  const { flowId } = useParams<{ flowId: string }>();
  const history = useHistory();
  const startYellowhiveOfferFlow = useStartYellowhiveOfferFlow();

  // Get selected insurances and coverages from yellowhive store
  const { insurances, coverages, products } =
    useYellowhiveFlowsConfigureStore();

  useEffect(() => {
    if (!insurances.length || !products.length) {
      return history.push({
        pathname: `${FLOWS_CONFIG_PATH}/${flowId}`,
        search: window.location.search,
      });
    }

    const currentType = queryParams.get('type');
    const inputUrl = currentType
      ? `${FLOWS_CONFIG_PATH}/${flowId}?type=${currentType}`
      : `${FLOWS_CONFIG_PATH}/${flowId}`;

    startYellowhiveOfferFlow({
      flowId: flowId,
      inputUrl,
      partyId: queryParams.get('partyId') || undefined,
      yellowhive_products: products.map((product) => ({
        id: product.id,
        coverages: product.coverages.map((coverage) => coverage.code),
      })),
    });
  }, [products, flowId, insurances, coverages, history]);

  return <QuestionViewSkeleton />;
};

export default FlowsConfigureYellowhiveFinish;
